import { Box, Button, FormControl, Grid, MenuItem, Select, Typography } from '@material-ui/core';
import Selector from '../Selector';
import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';

const CreateAutomationActions = observer(({ automationStore }) => {
  return (
    <div>
      <Grid container spacing={4}>
        <Grid item xs={4}>
          <Typography>
            <h3>Curtir trecho mais recente</h3>
          </Typography>
          <FormControl fullWidth>
            <Select
              value={automationStore.actionLikeLastQuote}
              onChange={e => automationStore.setAction('like_last_quote', e.target.value)}
            >
              <MenuItem value={false}>Não</MenuItem>
              <MenuItem value={true}>Sim</MenuItem>
            </Select>
          </FormControl>
          <br /><br />
          <Typography fontSize="small">
            Somente usuários de perfil público e que tenham publicado pelo menos um trecho terão seu trecho mais recente curtido.
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography>
            <h3>Seguir/Pedir para seguir</h3>
          </Typography>
          <FormControl fullWidth>
            <Select
              value={automationStore.actionFollow}
              onChange={e => automationStore.setAction('follow', e.target.value)}
            >
              <MenuItem value={false}>Não</MenuItem>
              <MenuItem value={true}>Sim</MenuItem>
            </Select>
          </FormControl>
          <br /><br />
          <Typography fontSize="small">
            Usuários de perfil público serão seguidos. Já usuários de perfil privado receberão uma solicitação para serem seguidos.
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography>
            <h3>Usuário executor</h3>
          </Typography>
          <FormControl fullWidth>
            <Select
              value={automationStore.actionUserId}
              onChange={e => automationStore.setAction('user_id', e.target.value)}
            >
              <MenuItem value=""></MenuItem>
              {automationStore.getAutomationUserList.map(user => (<MenuItem key={user.id} value={user.id}>{`${user.first_name} ${user.last_name}`}</MenuItem>))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      <br /><br />
      <Grid container spacing={4} justifyContent='flex-end'>
        <Grid item xs={12}>
          <Box display='flex' justifyContent='flex-end'>
            <Button variant="contained" onClick={async (e) => {
              await automationStore.saveActions();
            }}>Aplicar ações</Button>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
});

export default CreateAutomationActions;
